module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-afb0d47c.png";